import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Utenti'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Clienti'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Gruppi di lavoro'
, [ TEXT.UI_MENU_JOBS          ]: 'Lavori'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Padronanza delle Chiavi'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Creare'
, [ TEXT.UI_BUTTON_NEW         ]: 'Nuovo'
, [ TEXT.UI_BUTTON_OK          ]: 'Ok'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Annullare'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Salvare'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Login'
, [ TEXT.UI_BUTTON_SEND        ]: 'Lanciare'


, [ TEXT.UI_EMAIL              ]: 'E-mail'
, [ TEXT.UI_ROLE               ]: 'Ruolo'
, [ TEXT.UI_USERNAME           ]: 'Utente'
, [ TEXT.UI_NAME               ]: 'Nome'
, [ TEXT.UI_DATE               ]: 'Data'
, [ TEXT.UI_ADDR               ]: 'Indirizzo'
, [ TEXT.UI_DESC               ]: 'Descrizione'
, [ TEXT.UI_PRICE              ]: 'Prezzo'
, [ TEXT.UI_NO_DATA            ]: 'Nessun dato'
, [ TEXT.UI_MACHINES           ]: 'Macchine'
, [ TEXT.UI_USERS              ]: 'Utenti'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Disconnettersi'
, [ TEXT.UI_MKS_TYPE           ]: 'Tipo Padronanza delle Chiavi'
, [ TEXT.UI_KEY_APP            ]: 'Uso chiave'
, [ TEXT.UI_CLIENT             ]: 'Cliente'
, [ TEXT.UI_FILE               ]: 'Scheda'
, [ TEXT.UI_SELECT_FILE        ]: 'Seleziona Scheda'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Utente'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Cloud'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Password'



, [ TEXT.ARE_YOU_SURE          ]: 'Sei sicuro?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Utente / cloud o password errati'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Utente / cloud o password errati'
, [ TEXT.ERROR_INTERNAL        ]: 'Errore interno del server'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Accesso negato'
, [ TEXT.ERROR_UNKNOWN         ]: 'Si è verificato un errore e questo è tutto ciò che sappiamo'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Pagina non trovata'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Nuovo gruppo di lavoro'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Modifica gruppo di lavoro'
, [ TEXT.WORKGROUPS_NAME       ]: 'Nome'


, [ TEXT.USERS_NEW_TITLE       ]: 'Nuovo utente'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Modifica utente'


, [ TEXT.MACHINE_TYPE          ]: 'Tipo di macchina'
, [ TEXT.MACHINE_NUM_JOBS      ]: '# Lavori'


, [ TEXT.CLIENT_NEW_TITLE      ]: 'Nuovo cliente'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Modifica cliente'
, [ TEXT.CLIENT_ADDRESS        ]: 'Indirizzo'
, [ TEXT.CLIENT_CONTACT        ]: 'Contatto'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'E-mail'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Telefono'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Fax/Tlf'
, [ TEXT.CLIENT_SURNAMES       ]: 'Cognome'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Compleanno'
, [ TEXT.CLIENT_NOTES          ]: 'Nota'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Nome filtro'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Indirizzo filtro'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Filtro di contatto'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Indirizzo'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'Città'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'Provincia'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Cap'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'Nazione'


, [ TEXT.MACHINES_NEW          ]: 'Nuova macchina'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Numero di serie'
, [ TEXT.MACHINE_NAME          ]: 'Máquina'


, [ TEXT.JOB_EDIT_TITLE        ]: 'Modifica lavoro'
, [ TEXT.JOB_NEW_TITLE         ]: 'Nuovo lavoro'
, [ TEXT.JOB_KEY_TYPE          ]: 'Tipo chiave'
, [ TEXT.JOB_NUM_KEYS          ]: 'Quantità'
, [ TEXT.JOB_MACHINE           ]: 'Macchina'
, [ TEXT.JOB_STATUS            ]: 'Stato'
, [ TEXT.JOB_DATE              ]: 'Data'
, [ TEXT.JOB_QUANTITY          ]: 'Nuova quantità'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Stato del filtro'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Filtra i client'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filtra per macchina'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Filtra per chiave'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filtra per Data'

, [ TEXT.KEY_MASTERING_LAUNCH   ]: 'Inizio'
, [ TEXT.KEY_MASTERING_LAUNCH_N ]: 'Inizio ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE ]: 'Caricare Padronanza delle Chiavi'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: ' Verranno create {num} chiavi. Sei sicuro?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: '{num} lavori sono stati creati'
, [ TEXT.KEY_MASTERING_NAME               ]: 'Nome Padronanza delle Chiavi'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ]: 'Ha dimenticato la password?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE ]: 'Inviate le istruzioni di riposo a'
, [ TEXT.LOGIN_SLOGAN                   ]: 'La prima app di duplicazione delle chiavi basata su cloud'
, [ TEXT.LOGIN_QUALITY_POINTS           ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
<ul class="login-sell-points">
  <li>Registri le duplicazioni di chiavi realizzate per i Suoi clienti</li>
  <br>
  <li>Memorizzi i dati senza il rischio di perderli per accedervi da qualsiasi postazione</li>
  <br>
  <li>Aggiornamenti automatici</li>
</ul>
`

, [ TEXT.LEGAL_TOS_TEXT              ]: "Avviso legale"
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Politica sulla riservatezza'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Modello di accordo'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/it/legal_notice_it.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/it/privacy_policy_it.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/it/model_it.docx'

, [ TEXT.KEY_MODEL                   ]: 'Chiave'
, [ TEXT.KEY_SERIES                  ]: 'Serie'
, [ TEXT.KEY_CODE                    ]: 'Codice'
, [ TEXT.KEY_DATA_SHEET              ]: 'Scheda'
, [ TEXT.KEY_BITING                  ]: 'Cifratura'
, [ TEXT.KEY_APPLICATION             ]: 'Applicazione'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'IN ATTESA DI'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'ANNULLATO'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'COMPLETARE'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'IN LAVORAZIONE'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMIN'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'MANAGER'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USER'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'AUTO'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'CASA'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'SICUREZZA'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'LUCCHETTO'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'NON SPECIFICATO'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Si prega di compilare i campi obbligatori in rosso'
}

export default ES ;
